<template>
    <div class="tags-list">
        <div
            v-for="label in availableLabels"
            :key="label.id"
            class="tag-item"
            :class="{ selected: modelValue.includes(label.id) }"
            :style="{
                background: modelValue.includes(label.id) ? label.color : ''
            }"
            @click="toggleLabel(label.id)"
        >
            <span class="tag-name text-h4">{{ label.name }}</span>
            <span v-if="modelValue.includes(label.id)" class="tag-remove">
                <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1 1L9 9M9 1L1 9"
                        stroke="#ffffff"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </span>
        </div>
    </div>
</template>

<script>
import fetchWrapper from '@/helpers/fetch-wrapper.js'

export default {
    name: 'TagsComponent',
    props: {
        modelValue: {
            type: Array,
            default: () => []
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            availableLabels: []
        }
    },
    mounted() {
        this.loadLabels()
    },
    methods: {
        async loadLabels() {
            try {
                const response = await fetchWrapper.post(
                    `${import.meta.env.VITE_FINANCE_URL}/transactions/get-labels`,
                    {
                        search: '',
                        page: 1
                    }
                )

                const options = response?.labels?.data || []

                this.availableLabels = options.map((item) => ({
                    id: item.id,
                    name: item.name,
                    color: item.color
                }))
            } catch (error) {
                const errorMessage =
                    error.response?.data?.message || error.message || 'Помилка завантаження тегів'

                if (this.$toast) {
                    this.$toast.error(errorMessage)
                }
                console.error(error)
            }
        },
        toggleLabel(labelId) {
            const labels = [...this.modelValue]
            const index = labels.indexOf(labelId)

            if (index === -1) {
                labels.push(labelId)
            } else {
                labels.splice(index, 1)
            }

            this.$emit('update:modelValue', labels)
        }
    }
}
</script>

<style lang="scss" scoped>
.tags-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin-top: 0.75rem;

    .tag-item {
        display: flex;
        align-items: center;
        padding: 0.5rem 0.625rem;
        background: $grey-light;
        border-radius: 0.375rem;
        cursor: pointer;
        transition: all 0.2s ease;
        user-select: none;

        &.selected {
            .tag-name {
                color: $white;
            }
        }

        .tag-name {
            color: $black;
        }

        .tag-remove {
            display: flex;
            margin-left: 0.5rem;
            opacity: 0.6;

            &:hover {
                opacity: 1;
            }
        }
    }
}
</style>
